import { gql } from '@root/gql/utils/gql';

export const getDiscountCalculationsQuery = gql`
  query GetDiscountCalculations($dto: GetDiscountCalculationsDto!) {
    discountCalculations(dto: $dto) {
      possiblePurchasesWithDiscount {
        productId
        productOptionId
        discount {
          name
          priceReduction {
            value
            type
          }
          promoCode
        }
        discountOffersOnly {
          name
          priceReduction {
            value
            type
          }
        }
        discountedPrice
        discountedPriceOffersOnly
        fullPrice
      }
    }
  }
`;
